export const getDifficultyLevelText = (level) => {
  const difficultyLevel = {
    0: "Beginner (Foundational concepts, minimal prior knowledge required)",
    1: "Intermediate (Moderate complexity, builds on basic skills)",
    2: "Advanced (High difficulty, requires deep understanding)",
    3: "Expert (Extremely challenging, tests mastery and nuance)",
  };

  return difficultyLevel[level] ?? "";
};

export const getTimeComplexityLevelText = (level) => {
  const timeComplexityLevel = {
    0: "Quick (Under 1 Minute)",
    1: "Moderate (1-3 Minutes)",
    2: "Lengthy (Over 3 Minutes)",
  };
  return timeComplexityLevel[level] ?? "";
};
